import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Validation() {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "asset-copier-panel-validation",
    children: [/*#__PURE__*/_jsx(LoadingSpinner, {
      size: "medium",
      layout: "centered"
    }), /*#__PURE__*/_jsx(Text, {
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.validating"
      })
    })]
  });
}
export default Validation;